import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ChangeDetectionStrategy, inject } from '@angular/core';
import { Grid as InavistaGrid, GridConfig } from '@inavista/components/grid';
import { CommonService } from '../../services/common.service';
import { exportInavistaGrid } from '../../utils/inavista-grid-export';
import { LocalRowsGridApi, provideLocalGridRows } from '../../utils/local-rows-grid-api';
import { buildHistoryTabGridConfig, HISTORY_TAB_COLUMNS, HISTORY_TAB_URL } from './history-tab.grid.config';

// The old grid showed a page of 10 rows (pager 10/20/50/100). No paging now (Martin): the grid is as tall as its
// rows, up to 10, then scrolls. Toolbar + header + horizontal scrollbar, and the row height of the config.
const GRID_CHROME_PX = 92;
const ROW_PX = 30;
const MAX_VISIBLE_ROWS = 10;
const MIN_VISIBLE_ROWS = 2;

@Component({
    selector: 'app-history-tab-shared',
    templateUrl: './history-tab.component.html',
    styleUrls: ['./history-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
    // The grid reads the popup's history input, not an endpoint.
    providers: [...provideLocalGridRows()]
})
export class HistoryTabComponent implements OnInit, OnChanges {

  @Input() history = [];
  @Input() popup = [];

  @ViewChild('historyTabGrid') historyTabGrid: InavistaGrid;

  gridConfig: GridConfig = null;
  gridHeight = GRID_CHROME_PX + MIN_VISIBLE_ROWS * ROW_PX;
  private readonly rows = inject(LocalRowsGridApi);

  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    // Excel export showed for this role claim only, as before.
    this.gridConfig = buildHistoryTabGridConfig(!!this.commonService.roleClaims?.['AllGrid_Toolbar_Excel_Export']?.visible);
    this.refreshRows();
  }

  ngOnChanges(change: SimpleChanges): void {
    if (change?.history && !change.history.firstChange) {
      this.refreshRows();
    }
  }

  // The rows: the history input as it came. The Description (text) is shown as text, HTML encoded.
  refreshRows() {
    const history: any[] = Array.isArray(this.history) ? this.history : [];
    this.rows.set(HISTORY_TAB_URL, LocalRowsGridApi.schema(HISTORY_TAB_COLUMNS), history.map((h, i) => ({ ...h, rowId: i })));
    this.gridHeight = GRID_CHROME_PX + Math.min(Math.max(history.length, MIN_VISIBLE_ROWS), MAX_VISIBLE_ROWS) * ROW_PX;
    this.historyTabGrid?.refresh();
  }

  // The old file name: "<popup> History(<date>).xlsx", the rows the grid shows, the visible columns.
  onExportRequested() {
    exportInavistaGrid(this.historyTabGrid, `${this.popup} History`);
  }

}
